import { Image, Text } from '@chakra-ui/core'
import React from 'react'
import { Maybe, PopularTaskDefinitionEntityWithCount } from '../../../../generated/graphql'
import { Card } from '../../../../components'
import { images } from '../../../../theme'
import { CardProps } from '../../../../components/Card'

type ListItemProps = {
  task: Maybe<PopularTaskDefinitionEntityWithCount>
} & CardProps

const ListItem: React.FC<ListItemProps> = ({ task, ...rest }) => {
  return (
    <Card rounded="lg" p={5} mb={4} mr={3} cursor={'pointer'} minW={48} {...rest}>
      <Image
        src={
          task?.taskDefinition?.attributes?.category?.data?.attributes?.featureImage?.data
            ?.attributes?.formats?.thumbnail?.url || images.baotreeLogo
        }
        alt={task?.taskDefinition.attributes?.project?.data?.attributes?.name || 'Project Image'}
        objectFit="cover"
        rounded="lg"
        w={38}
        h={38}
        mb={2}
        bg="gray.100"
        p={1}
      />

      <Text fontSize="xs" color="gray.500" mb={3}>
        {task?.taskDefinition.attributes?.project?.data?.attributes?.name || 'Unknown Project'}
      </Text>
      <Text fontSize="sm" fontWeight="500" color="gray.700">
        {task?.taskDefinition.attributes?.task_type?.data?.attributes?.title || 'Unknown Task'}
      </Text>
      <Text fontSize="xs" color="gray.400">
        <Text as="b" fontSize="sm" color="gray.800">
          {task?.count}
        </Text>{' '}
        tasks reported
      </Text>
    </Card>
  )
}

export default ListItem
